// #ux-redesign-start: LoadingBlock primitive (Paso 5 - Sistema de carga unificado)
// Reemplazo drop-in de <LoadingLocal/> (plugin legacy). Centra un Spinner del
// DS con padding consistente. Sirve también como <Suspense fallback={...}>.
//
// USO
//   <LoadingBlock />                              // mínimo, sin texto
//   <LoadingBlock label={t('loading-studies')} /> // con texto debajo
//   <LoadingBlock size="lg" padded="lg" />        // pantalla vacía
//   <Suspense fallback={<LoadingBlock />}>        // chunks lazy
//
// PORTABILIDAD: trasplantable a Web-Patients sin cambios.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';
import Spinner from './Spinner';

const LoadingBlock = ({
  size = 'md',
  label = null,
  ariaLabel,
  padded = 'md',
  minHeight,
  className = '',
}) => {
  const style = minHeight ? { minHeight } : undefined;
  return (
    <div
      className={`ds-loading-block ds-loading-block--pad-${padded} ${className}`.trim()}
      style={style}
    >
      <Spinner size={size} ariaLabel={ariaLabel || label || 'Laden…'} />
      {label && <span className="ds-loading-block__text">{label}</span>}
    </div>
  );
};

LoadingBlock.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  label: PropTypes.node,
  ariaLabel: PropTypes.string,
  padded: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export default LoadingBlock;
// #ux-redesign-end
